import { create } from 'zustand';

export const useAuth = create((set, get) => ({
  user: null,
  loading: false,
  error: null,
 isLoggingOut: false,
  /** 🔐 Rozpoczęcie logowania */
  loginStart: () => set({ loading: true, error: null }),

  /** ✅ Logowanie zakończone sukcesem */
  loginSuccess: (user) => set({ user, loading: false, error: null }),

  /** ❌ Logowanie nieudane */
  loginError: (error) => set({ user: null, loading: false, error }),

  /** 🚪 Wylogowanie użytkownika */
 logout: async (onComplete) => {
  set({ user: null, loading: false, error: null, isLoggingOut: true });

  try {
    const res = await fetch('https://hs2api.razamit.pl/logout', {
      method: 'POST',
      credentials: 'include',
    });

    // ⏳ Poczekaj chwilę, aż przeglądarka przetworzy Set-Cookie
    await new Promise((resolve) => setTimeout(resolve, 50));

  } catch (err) {
    console.warn('Logout error:', err);
  }

  set({ isLoggingOut: false });
  if (onComplete) onComplete();
},

  /** 🧠 Sprawdzenie, czy użytkownik jest zalogowany */
 checkAuth: async () => {
  if (get().isLoggingOut) {
    console.log('⛔ Pomijam checkAuth — trwa wylogowanie');
    return null;
  }

  set({ loading: true });
  try {
    const res = await fetch('https://hs2api.razamit.pl/me', {
      method: 'GET',
      credentials: 'include',
    });
    if (!res.ok) {
      set({ user: null, loading: false });
      return null;
    }
    const data = await res.json();
    set({ user: data, loading: false });
    return data;
  } catch (err) {
    set({ user: null, loading: false });
    return null;
  }

}

}));
